<template>
  <div>
    <van-nav-bar title="会员中心" class="">
      <template #left>
        <!-- <span
          v-if="!$store.state.loginType"
          @click="$router.push('/login')"
          class="navTextDesign"
          >签到</span
        >
        <span
          v-if="$store.state.loginType"
          @click="signIn"
          class="navTextDesign"
          >签到</span
        > -->
        <div id="lineUrlDropMenu">
          <van-dropdown-menu id="lineUrlDropdown">
            <van-dropdown-item v-model="activeLineUrl" :options="lineArray" @change="changeTab" />
          </van-dropdown-menu>
        </div>
      </template>
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span
          @click="openQchat()"
          class="navTextDesign"
          >在线客服</span
        >
      </template>
    </van-nav-bar>

    <!-- <van-nav-bar v-if="!$store.state.loginType" title="会员中心" class="">
      <template #right>
        <span @click="$router.push('/login')" class="navTextDesign">签到</span>
        <van-icon name="chat-o" size="25" @click="openQchat()" />
      </template>
    </van-nav-bar> -->
    <van-pull-refresh v-model="isLoading" @refresh="getUser">
      <div class="members">
        <van-row style="text-align: right; padding: 10px 10px 0;">
            <van-button
              round
              plain
              v-if="!$store.state.loginType"
              type="danger"
              size="normal"
              class="members-button"
              style="height: 26px; width: 65px; border-radius: 8px"
              @click="$router.push('/login')"
              >签到</van-button
            >
            <van-button
              round
              plain
              v-if="$store.state.loginType"
              type="danger"
              size="normal"
              class="members-button"
              style="height: 26px; width: 65px; border-radius: 8px"
              @click="signIn"
              >签到</van-button
            >
        </van-row>
        <div class="members-img">
          <!-- <img
            :src="$store.state.login_logo_url"
            style="width: 100%"
            v-if="$store.state.login_logo_url"
          /> -->
          <img
            :src="require('../assets/images/login_logo.png')"
            style="width: 100%"
          />
        </div>

        <van-row
          v-if="$store.state.loginType"
          style="padding-top: 10px; text-align: center"
        >
          <van-col span="8">
            <!-- <router-link to="recharge"> -->
            <van-button
              round
              type="danger"
              size="normal"
              class="members-button"
              style="height: 26px"
              @click="goToRechargePage()"
              >充值</van-button
            >
            <!-- </router-link> -->
          </van-col>
          <van-col span="8"
            ><p class="members-user">{{ phone }}</p></van-col
          >
          <van-col span="8">
            <!-- <router-link to="withdrawal"> -->
            <van-button
              round
              type="info"
              size="normal"
              class="members-button"
              style="height: 26px"
              @click="goToWithdrawPage()"
              >提现</van-button
            >
            <!-- </router-link> -->
          </van-col>
        </van-row>
        <div v-if="!$store.state.loginType">
          <van-row style="padding-top: 10px; text-align: center">
            <van-col span="11" style="text-align: right">
              <router-link to="/login">
                <van-button
                  round
                  plain
                  type="danger"
                  size="normal"
                  class="members-button"
                  style="height: 26px; width: 65px; border-radius: 8px"
                  >登录</van-button
                >
              </router-link>
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11" style="text-align: left">
              <router-link to="/zhuce9999">
                <van-button
                  round
                  plain
                  type="danger"
                  size="normal"
                  class="members-button"
                  style="height: 26px; width: 65px; border-radius: 8px"
                  >注册
                </van-button>
              </router-link>
            </van-col>
          </van-row>
        </div>
      </div>
      <van-row v-if="$store.state.loginType" style="padding: 10px 10px 5px">
        <van-col span="12">
          <p class="members-money">余额: {{ cash }}元</p>
        </van-col>
        <van-col span="12" style="text-align: right"
          ><p class="members-money" style="padding-right: 6px">
            代金券: {{ voucherAmount }}元
          </p></van-col
        >
      </van-row>
      <van-row v-if="$store.state.loginType" style="padding: 0px 10px 10px">
        <van-col span="12">
          <p class="members-money">时时宝: {{ timebaoAccount }}元</p>
        </van-col>
        <van-col span="12" style="text-align: right"
          ><p class="members-money" style="padding-right: 6px">
            累计收益: {{ timebao_interest_amount }}元
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <!-- ============================= 1 ======================================== -->
        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <van-cell title="资金明细" is-link @click="gotoLink('detailed_log')" />
        <van-cell
          is-link
          @click="gotoLink('time_bao')"
          v-if="timebao_status == 1"
        >
          <template #title>
            <span class="custom-title">时时宝</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >炒股理财时时赚钱 年化收益{{ timebao_annualized_rate }}%</span
            >
          </template>
        </van-cell>
        <!-- add gx cell -->
        <van-cell
          is-link
          @click="gotoLink('gxpay')"
        >
          <template #title>
            <span class="custom-title">Gxpay</span>
            <span style="font-size: 10px;">&nbsp (第三方数字货币合作机构)</span>
            
          </template>
        </van-cell>
        <van-cell
          is-link
          @click="$router.push({ name: 'DetailedLog', params: { tab: 6 } })"
        >
          <template #title>
            <span class="custom-title">代金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >{{ voucherAmount }}元</span
            >
          </template>
        </van-cell>
        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <!-- ============================= 2 ======================================== -->
        <van-cell title="风控通知" is-link @click="gotoLink('risk_control')" />
        <van-cell title="平台公告" is-link @click="gotoLink('announcement')" />
        <van-cell
          title="完善个人资料"
          is-link
          @click="gotoLink('information')"
        />
        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <!-- ============================= 3 ======================================== -->
        <van-cell is-link @click="gotoLink('/create_capital_accounts')">
          <template #title>
            <span class="custom-title">申请配资</span>
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('/capital_account?activeTab=2')">
          <template #title>
            <span class="custom-title">配资账户</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >保证金{{ bond }}元</span
            >
          </template>
        </van-cell>

        <van-cell title="实盘交易" is-link @click="gotoLink('/trading')" />
        <van-cell title="自选股票" is-link @click="gotoLink('/quotes')" />

        <van-cell
          title="委托查询"
          is-link
          @click="gotoLink('entrust_inquiry')"
        />
        <van-cell
          title="撤单查询"
          is-link
          @click="gotoLink('withdrawal_inquiry')"
        />
        <van-cell title="成交查询" is-link @click="gotoLink('deal_inquiry')" />
        <van-cell
          title="持仓查询"
          is-link
          @click="gotoLink('position_inquiry')"
        />
        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <!-- ============================= 4 ======================================== -->
        <van-cell is-link @click="gotoLink('agency')">
          <template #title>
            <span class="custom-title">推广账号</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >{{ parseFloat(agent_account).toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('friend_coupon')">
          <template #title>
            <span class="custom-title">好友现金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >{{ parseFloat(friend_cash_coupon).toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('user_coupon')">
          <template #title>
            <span class="custom-title">我的好友现金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #ee0a24"
              >{{ parseFloat(my_cash_voucher).toFixed(2) }}元</span
            >
          </template>
        </van-cell>

        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <!-- ============================= 5 ======================================== -->
        <van-cell
          title="线路切换"
          is-link
          to=""
          @click="lineSwitching = true"
        />
        <!-- <van-cell title="联系客服" is-link to="/service" /> -->
        <van-cell title="联系客服" is-link @click="openQchat()" />
        <!-- ============================= 6 ======================================== -->
        <van-row v-if="finance_status == 1 || holiday_status === 1">
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <div>
          <van-cell
            title="定期宝"
            is-link
            @click="gotoLink('finance_fund')"
            v-if="finance_status == 1"
          />
        </div>
        <div>
          <van-cell
            title="节日宝"
            is-link
            @click="gotoLink('holiday_fund')"
            v-if="holiday_status == 1"
          />
        </div>
      </van-cell-group>
      <van-row style="padding: 0px 10px 10px">
        <van-col span="12">
          <p class="version">版本号 / 包号</p> 
        </van-col>
        <van-col span="12" style="text-align: right; color: #727573" >
          {{ version }} / {{ description }}
        </van-col>
      </van-row>
      <van-button
        v-if="$store.state.loginType"
        type="danger"
        block
        @click="exitLogin"
        >退出登录</van-button
      >
    </van-pull-refresh>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->

    <van-popup v-model="isRealNameVerified" style="width: 70%; height: 158px">
      <div>
        <h5 style="padding-top: 1px; text-align: center">您还没有实名</h5>
        <h5 style="padding-top: 1px; text-align: center">
          请实名激活<span>&nbsp;{{ sys_give_voucher_amount }}&nbsp;</span>元礼金
        </h5>
        <span
          ><van-button
            type="danger"
            size="large"
            @click="cancel"
            style="
              width: 40%;
              margin-left: 7%;
              height: 30%;
              padding: 3px;
              margin-top: 10px;
              border-radius: 6px;
            "
            >取消
          </van-button>
          <van-button
            type="danger"
            size="large"
            @click="goToRealName"
            style="
              width: 40%;
              margin-left: 5%;
              height: 30%;
              padding: 3px;
              margin-top: 10px;
              border-radius: 6px;
            "
            >立即实名
          </van-button>
        </span>
      </div>
    </van-popup>
    <van-popup v-model="isFirstTimeRecharge" style="width: 90%; height: auto">
      <div class="popupContent">
        <p style="text-align: center; font-size: 17px; display: none">
          首充礼品清单
        </p>
        <div v-html="before_recharge" @click="goToRechargePopContent"></div>
        <van-button
          type="danger"
          size="large"
          @click="cancelRecharge"
          style="
            width: 40%;
            margin-left: 7%;
            height: 30%;
            padding: 3px;
            border-radius: 6px;
            margin-bottom: 42px;
          "
          >取消
        </van-button>
        <van-button
          type="danger"
          size="large"
          @click="goToRecharge"
          style="
            width: 40%;
            margin-left: 5%;
            height: 30%;
            padding: 3px;
            border-radius: 6px;
            margin-bottom: 42px;
          "
          >立即充值
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="isFirstTimeTrading" style="width: 90%; height: auto">
      <div class="popupContent">
        <p style="text-align: center; font-size: 17px">首充礼品清单</p>
        <div v-html="before_recharge"></div>
        <van-button
          type="danger"
          size="large"
          @click="cancelTrade"
          style="width: 40%; margin-left: 7%; height: 30%"
          >取消
        </van-button>
        <van-button
          type="danger"
          size="large"
          @click="goToTrade"
          style="width: 40%; margin-left: 5%; height: 30%"
          >立即配资交易
        </van-button>
      </div>
    </van-popup>

    <van-popup v-model="lineSwitching" round :style="{ width: '70%' }">
      <!-- <div class="download">
        <h4 class="downloadTitle">Line Switching</h4>
        <van-divider />
        <van-radio-group>
          <van-cell-group>
            <van-cell title="Line 1" clickable @click="radio = '1'">
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
            <van-cell title="Line 2" clickable @click="radio = '2'">
              <template #right-icon>
                <van-radio name="2" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-divider />
        <van-button
          type="danger"
          size="large"
          @click="download"
          style="width: 50%; margin-left: 5%"
          >a
        </van-button>
        <van-divider />
        <van-button
          type="danger"
          size="large"
          @click="download"
          style="width: 50%; margin-left: 5%"
          >a
        </van-button>
      </div> -->
      <h5 style="padding-top: 1px; text-align: center">线路切换</h5>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(item) in lineTypes"
            :key="item.id"
            :title="item.name"
            clickable
            @click="radioName = item.id"
          >
            <template #right-icon>
              <input
                type="radio"
                :value="item.id"
                :checked="item.id == urlBaseId"
                name="switch_change"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div style="padding-top: 12px">
        <van-button
          type="info"
          size="small"
          plain
          @click="cancelLines"
          style="
            width: 26%;
            margin-left: 17%;
            margin-bottom: 5%;
            border-radius: 5px;
          "
          >取消
        </van-button>

        <van-button
          type="info"
          size="small"
          plain
          @click="ChangeLine"
          style="
            width: 26%;
            margin-left: 13%;
            margin-bottom: 5%;
            border-radius: 5px;
          "
          >确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Browser } from "@capacitor/browser";
import { version,description } from './../../package.json'
import { ref } from "vue";
export default {
  name: "Members",
  data() {
    return {
      version: version,
      description : description,
      isLoading: false,
      phone: "",
      cash: 0.0,
      bond: 0.0,
      timebao_annualized_rate: 0.0,
      timebao_interest_amount:0.0,
      timebaoAccount: 0.0,
      voucherAmount: 0.0,
      agent_account: 0.0,
      my_cash_voucher: 0.0,
      friend_cash_coupon: 0.0,
      isRealNameVerified: false,
      isFirstTimeRecharge: false,
      isFirstTimeTrading: false,
      lineSwitching: false,
      sys_give_voucher_amount: "",
      before_recharge: "",
      before_trading: "",
      isRealNamePopShow: false,
      isRechargePopShow: false,
      radio: 1,
      radioName: 1,
      lineTypes: this.$URLs,
      urlBase: localStorage.getItem("lineUrl"),
      urlBaseId: localStorage.getItem("lineUrlId"),
      finance_status: "",
      holiday_status: "",
      timebao_status: "",
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      qserver_url: "",
      activeLineUrl: 1,
      lineArray: [],
      unreadRiskCount:0,
    };
  },
  methods: {
    openQchat() {
      // if (Capacitor.getPlatform() === "android") {
      //   //check if android app, if android app use native plugin to open popup
      //   Browser.open({ url: this.qserver_url });
      // } else {
      //   window.open(this.qserver_url);
      // }
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    gotoLink(link) {
      if (sessionStorage.getItem("token")) {
        //calling api for gxpay
      if(link == "gxpay"){
        let that = this;
       that
         .$http({
           url: "/",
           method: "POST",
           data: {
             nozzle: "gxpay_thirdparty_digital_currency",
             token: sessionStorage.getItem("token"),
           },
         })
         .then((ret) => {
           let resData = ret.data;
           if (resData.code == 1) {
            if(resData.data.user == true){
              this.$router.push(link); 
            }
           else{
           window.open(resData.data.homeUrl,'_blank');
           }

           }
         });
      }
      else{
        this.$router.push(link);

      }
      } else {
        this.$router.push("/login");
      }
    },
    goToRechargePopContent() {
      this.$router.push({
        path: "/activity/popup_content?activityid=recharge_popup_image_mob",
      });
    },
    signIn() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "checkin",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.$toast.success(resData.msg);
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    // ==================== Check trade channel before go to recharge and withdraw  page =============
    goToRechargePage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/recharge");
      }
    },

    goToWithdrawPage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/withdrawal");
      }
    },

    // ============= get the content of trade channel popup agreement ===========

    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // that.$toast.fail(res.data.msg);
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },

    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "sys_give_voucher_amount",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.sys_give_voucher_amount = res.data.data;
          } else {
          }
        });
    },
    rechargeConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "before_recharge",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.before_recharge = res.data.data;
          } else {
          }
        });
    },
    getUser() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            let resData = res.data;
            that.isLoading = false;
            if (res.data.code === 1) {
              that.cash = resData.data.cash;
              that.timebao_annualized_rate =
                resData.data.timebao_annualized_rate;
              that.timebao_interest_amount = resData.data.timebao_interest_amount;
              that.timebaoAccount = resData.data.timebao_accout;
              that.bond = resData.data.bond;
              that.agent_account = resData.data.agent_account;
              that.friend_cash_coupon = resData.data.friend_cash_coupon;
              that.my_cash_voucher = resData.data.my_cash_voucher;
              that.voucherAmount = resData.data.voucher_management;
              that.phone = resData.data.phone;
              that.finance_status = resData.data.finance_status;
              that.holiday_status = resData.data.holiday_status;
              that.timebao_status = resData.data.timebao_status;
              that.trade_channel_status = resData.data.trade_channel_status;
              that.$store.commit("changeUser", resData.data);
              if (resData.data.real == "") {
                if (that.isRealNamePopShow) {
                  that.realNameConfig();
                  that.isRealNameVerified = true;
                }
              }
              if (resData.data.real) {
                //
                that.isFirstRecharge();
                //   if(resData.data.cash == "0.00") {
                //     that.rechargeConfig();
                //     that.isFirstTimeRecharge = true;
                // } else {
                //     that.isFirstTimeRecharge = false;
                //     //call is trade
                //   // that.isFirstTrade();
                // }
              }
            } else if (res.data.code === 0) {
              that.$toast.fail(resData.msg);
            } else if (res.data.code === -1) {
              that.$store.commit("changeLoginType", false);
              that.$router.push("/login");
            }
          })
          .catch(() => {
            that.isLoading = false;
          });
      }
    },
    isFirstRecharge() {
      //  if(resData.data.cash == "0.00") {
      //         that.rechargeConfig();
      //         that.isFirstTimeRecharge = true;
      //     } else {
      //         that.isFirstTimeRecharge = false;
      //         //call is trade
      //       // that.isFirstTrade();
      //     }
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "isfirst_recharge",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.data == 1) {
            that.isFirstTimeRecharge = false;
            // that.isFirstTrade();
            // localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            if (that.isRechargePopShow) {
              that.rechargeConfig();
              that.isFirstTimeRecharge = true;
            }
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    isFirstTrade() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "isfirst_deal",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          // console.log("res", res.data.data);
          if (res.data.data == 1) {
            that.isFirstTimeTrading = false;
            localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            that.tradeConfig();
            that.isFirstTimeTrading = true;
            localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    tradeConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "before_trading",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.before_trading = res.data.data;
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    cancelLines() {
      this.lineSwitching = false;
    },
    cancel() {
      this.isRealNameVerified = false;
    },
    cancelRecharge() {
      this.isFirstTimeRecharge = false;
    },
    cancelTrade() {
      this.isFirstTimeTrading = false;
    },
    goToRealName() {
      this.$router.push("/member/information/real_name");
    },
    goToRecharge() {
      this.$router.push("/member/recharge");
    },
    goToTrade() {
      this.$router.push("stockdetailed?symbol:'sh000001'");
    },
    exitLogin() {
      this.$store.commit("changeLoginType", false);
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("along");
      localStorage.setItem("user_number", "");
      //call service
      // this.logout();
      localStorage.clear();
      this.$router.push("/login");
      location.reload();
    },
    isRealNamePopShowM() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "sysconfig",
              token: sessionStorage.getItem("token"),
              name: "is_real_name_popup",
            },
          })
          .then(function (res) {
            if (res.data.data == 1) {
              that.isRealNamePopShow = true;
            } else {
              // that.isFirstTimeTrading = true;
              // localStorage.setItem("isFirstTimeRecharge", true);
            }
          });
      }
    },
    isRechargePopShowM() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "sysconfig",
              token: sessionStorage.getItem("token"),
              name: "is_before_recharge",
            },
          })
          .then(function (res) {
            if (res.data.data == 1) {
              that.isRechargePopShow = true;
            } else {
              // that.isFirstTimeTrading = true;
              // localStorage.setItem("isFirstTimeRecharge", true);
            }
          });
      }
    },
    ChangeLine() {
      let that = this;
      that.$toast.loading({
        forbidClick: true,
      });
      let lineId = that.radioName?that.radioName:this.urlBaseId;
      localStorage.setItem("lineUrl", this.lineTypes.find((o)=>o.id==lineId).url);
      localStorage.setItem("lineUrlId", this.lineTypes.find((o)=>o.id==lineId).id);
      sessionStorage.setItem("lineUrl", this.lineTypes.find((o)=>o.id==lineId).url);
      sessionStorage.setItem("lineUrlId",this.lineTypes.find((o)=>o.id==lineId).id);
      setTimeout(() => {
        location.reload();
      }, 500);
      this.lineSwitching = false;
    },
    //---------- line url selection start
    changeTab(value) {
      this.$toast.loading({
        forbidClick: true,
      });
      localStorage.setItem("lineUrl", this.lineTypes.find((o)=>o.id==value).url);
      localStorage.setItem("lineUrlId", this.lineTypes.find((o)=>o.id==value).id);
      sessionStorage.setItem("lineUrl", this.lineTypes.find((o)=>o.id==value).url);
      sessionStorage.setItem("lineUrlId",this.lineTypes.find((o)=>o.id==value).id);
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    getCurrentLineUrl() {
      let line = this.lineTypes.find((o)=>o.id == this.urlBaseId);
      if(line){
        this.activeLineUrl=line.id;
      }
    },
  },

  mounted: function () {
    this.lineTypes.forEach(element => {
      this.lineArray.push({text:element.name,value:element.id})
    });
    let that = this;
    this.get_qchat_server_url();
    that.isRealNamePopShowM();
    that.isRechargePopShowM();
    that.getUser();
    this.getCurrentLineUrl();
    if (that.$store.state.rechargeType === true) {
      this.$toast.success({
        message: "充值申请成功，尽快完成后续操作，联系客服吧",
      });
    }
    that.$store.commit("rechargeTypeNine", false);
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.navTextDesign {
  /* border: 1px solid #ffffff; */
  color: #ffffff;
  font-size: 14px;
  /* padding: 0px 10px; */
  /* margin-right: 15px; */
  /* border-radius: 6px; */
}
.members-wrap {
}
.members {
  /* background: #ee0a24; */
  height: 231px;
  width: 100%;
  margin: 0 auto;
}
.members-img {
  width: 120px;
  margin: 0 auto;
  text-align: center;
  /* padding-top: 20px; */
}
.members-user {
  margin: 0;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 30px;
}
.members-money {
  font-size: 14px;
  /* color: #ffff; */
  margin: 0;
  padding-left: 6px;
}
.version {
  font-size: 14px;
  margin: 0;
  padding-left: 8px;
 }
.members-down {
  margin-top: 10px;
}

.divideSection {
  height: 5px;
  background: #f1f1f1;
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
}
</style>
<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}

#lineUrlDropdown .van-dropdown-item__option {
  background-color: #ee0a24;
  padding: 5px 10px;
  text-align: center;
  font-size: 12px;
}

#lineUrlDropdown .van-dropdown-item__content {
  background-color: #ee0a24;
  width: 87px;
  position: absolute;
  left: 16px;
  top: 2px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

#lineUrlDropdown .van-overlay {
  background-color: transparent;
}

#lineUrlDropdown .van-dropdown-menu__item {
  background-color: #ee0a24;
}

#lineUrlDropdown .van-dropdown-menu__title::after {
  display: none;
}

#lineUrlDropdown .van-dropdown-item__option .van-cell__value {
  display: none;
}

#lineUrlDropdown .van-dropdown-item__option .van-cell__title {
  color: #fff;
}

#lineUrlDropMenu .van-dropdown-menu {
  /* border: 1px solid #ffffff; */
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}

#lineUrlDropdown .van-dropdown-menu__bar {
  height: auto;
  box-shadow: none;
}

#lineUrlDropdown .van-dropdown-menu__title {
  color: #fff;
}

#lineUrlDropdown .van-cell::after {
  border-bottom: 3px solid #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Members.vue